import React from "react";
type Props = {
  updateWizard: (e: any, setActive: boolean) => void;
  selectedWizard: number;
  content?: any;
  addInfo?: any;
};

export default function WizardComponent({
  selectedWizard,
  updateWizard,
  content,
  addInfo,
}: Props) {
  return (
    <div className="wizard">
      <div
        className={"wizard-item active"}
        onClick={() => updateWizard(1, true)}
      >
        1
      </div>
      <div
        className={selectedWizard > 1 ? "wizard-line active" : "wizard-line"}
      ></div>
      <div
        className={selectedWizard > 1 ? "wizard-item active" : "wizard-item"}
        onClick={content ? () => updateWizard(2, true) : () => {}}
      >
        2
      </div>
      <div
        className={selectedWizard > 2 ? "wizard-line active" : "wizard-line"}
      ></div>
      <div
        className={selectedWizard > 2 ? "wizard-item active" : "wizard-item"}
        onClick={addInfo ? () => updateWizard(3, true) : () => {}}
      >
        3
      </div>
    </div>
  );
}
